export function hexWithTransparency(hex, alpha = 0.2) {
  hex = hex.replace(/^#/, '');
  let r, g, b;
  if (hex.length === 3) {
    r = parseInt(hex[0] + hex[0], 16);
    g = parseInt(hex[1] + hex[1], 16);
    b = parseInt(hex[2] + hex[2], 16);
  } else if (hex.length === 6) {
    r = parseInt(hex.substring(0, 2), 16);
    g = parseInt(hex.substring(2, 4), 16);
    b = parseInt(hex.substring(4, 6), 16);
  } else {
    return hex;
  }
  const alphaHex = Math.round(alpha * 255)
    .toString(16)
    .padStart(2, '0');
  return `#${hex}${alphaHex}`;
}

export const newRandomColor = () => {
  let r, g, b;
  do {
    r = Math.floor(Math.random() * 180) + 50; // Permite valores hasta 255 pero evita los más oscuros (<50)
    g = Math.floor(Math.random() * 180) + 50;
    b = Math.floor(Math.random() * 180) + 50;
  } while (
    (r > 220 && g > 220 && b > 220) || // Evita el blanco y tonos muy cercanos a él
    (Math.abs(r - g) < 20 && Math.abs(g - b) < 20 && Math.abs(r - b) < 20)
  ); // Evita tonos grises

  return `rgb(${r}, ${g}, ${b})`;
};

export const newPastelColor = () => {
  // Generamos un color principal "vivo"
  const h = Math.floor(Math.random() * 360); // tono aleatorio

  const main = `hsla(${h}, 100%, 64%, 1)`;

  // Creamos el fondo a partir del color principal, pero más suave
  const secondary = `hsla(${h}, 100%, 93%, 1)`;

  return { main, secondary };
};

export const pastelColors = Object.freeze([
  {
    main: 'hsla(167, 93%, 33%, 1)',
    secondary: 'hsla(166, 66%, 90%, 1)',
  },
  {
    main: 'hsla(131, 51%, 44%, 1)',
    secondary: 'hsla(131, 60%, 93%, 1)',
  },
  {
    main: 'hsla(30, 93%, 53%, 1)',
    secondary: 'hsla(30, 100%, 93%, 1)',
  },
  {
    main: 'hsla(213, 100%, 64%, 1)',
    secondary: 'hsla(213, 100%, 93%, 1)',
  },
  {
    main: 'hsla(250, 67%, 67%, 1)',
    secondary: 'hsla(250, 68%, 93%, 1)',
  },
  {
    main: 'hsla(43, 100%, 42%, 1)',
    secondary: 'hsla(43, 100%, 90%, 1)',
  },
  {
    main: 'hsla(358, 100%, 69%, 1)',
    secondary: 'hsla(358, 100%, 94%, 1)',
  },
  {
    main: 'hsla(9, 100%, 67%, 1)',
    secondary: 'hsla(9, 100%, 94%, 1)',
  },
]);

export const getPastelColorExcluding = (exclude = []) => {
  if (!exclude.length)
    return pastelColors[Math.floor(Math.random() * pastelColors.length)];

  const colors = pastelColors.filter((x) =>
    [x.main, x.secondary].every((y) => !exclude.includes(y))
  );
  return colors.length
    ? colors[Math.floor(Math.random() * colors.length)]
    : newPastelColor();
};
